// -----------------------------------------------------------------------------
// Script for faq list
// -----------------------------------------------------------------------------

function itineraryTab() {
  $(".itinerary__title, .itinerary__day").on("click", function () {
    var parent = $(this).parents(".itinerary__item");
    parent.toggleClass("itinerary__item--active");
    parent.find(".itinerary__content-inner").slideToggle("slow");
    $(".itinerary-full").slick("reinit");
  });
}
